import { styled, keyframes } from '@acko-tech/building-blocks.ui.common';
import { resolvePath } from 'Utils/resolvePath';

import Layout from '@/components/common/layout';

const slideUp = keyframes`
    0% {
        transform: translateY(20px);
        opacity: 0;
    }
    100% {
        transform: translateY(0px);
        opacity: 1;
    }
`;

export const Pricing = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;

    .discounted {
        font-size: 20px;
        line-height: 28px;
        font-weight: 600;
    }

    .price {
        font-size: 12px;
        line-height: 16px;
        text-decoration: line-through;
        font-weight: 400;
    }

    .discount {
        font-size: 12px;
        line-height: 18px;
        font-weight: 500;
        color: #00aa58;
    }
`;

export const Wrapper = styled(Layout)`
    .layoutWrapper {
        padding: 0;
        background: ${(props: any) =>
            props.interestSubmitted ? 'black' : 'black'};

        @media (max-width: 700px) {
            padding: 0;
            background: ${(props: any) =>
                props.interestSubmitted ? 'black' : 'black'};
        }
    }
`;

export const Banner = styled.div<{ interestSubmitted: boolean }>`
    padding: 50px;
    opacity: 0;
    animation: ${slideUp} 0.4s 0.1s forwards;
    background-image: url('${resolvePath('/images/acko-garage-new.png')}');
    background-size: cover;
    background-position: center;
    z-index: -1;
    height: 35vh;
`;

export const FeatureContainer = styled.div`
    display: flex;
    gap: 8px;
    flex-wrap: nowrap;
    color: white;
    font-size: 12px;
    justify-content: space-around;
    overflow-x: auto;
    margin-bottom: 16px;
`;

export const IconBox = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
    text-align: center;
`;

export const Icon = styled.div`
    display: flex;
    width: 56px;
    height: 56px;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: transparent;
    backdrop-filter: blur(12px);
    justify-content: center;
    align-items: center;
`;
export const Back = styled.div`
    height: 12px;
    width: 12px;
    border: 2px solid transparent;
    border-left: 2px solid white;
    border-bottom: 2px solid white;
    transform: rotate(45deg);
    border-radius: 2px;
    cursor: pointer;
`;

export const ADLogo = styled.img`
    display: block;
    margin: auto;
    opacity: 0;
    height: 50px;
    animation: ${slideUp} 0.4s 0.125s forwards;
`;

export const HeadingContainer = styled.div`
    margin: 50px auto;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const GarageDetails = styled.div`
    padding-bottom: 30px;
`;

export const Heading = styled.div`
    text-align: center;
    margin: auto;
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: 169%;
    margin: 0 auto 10px;
    background: white;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    opacity: 0;
    animation: ${slideUp} 0.4s 0.15s forwards;
    & > span {
        font-size: 10px;
        letter-spacing: 4px;

        line-height: 22px;
        color: #fff;
    }
`;

export const GoogleRatingContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    width: fit-content;
    border-radius: 40px;
    backdrop-filter: blur(7px);
    padding: 8px 20px;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    color: #4b4b4b;
    opacity: 0;
    animation: ${slideUp} 0.4s 0.125s forwards;
    gap: 8px;

    > span {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 3px;
    }
`;

export const VerticalDivider = styled.div`
    border-left: 1px solid #e8e8e8;
    height: 14px;
    width: 2px;
`;

export const SubHeading = styled.div`
    font-size: 16px;
    line-height: 22px;
    font-weight: 600;

    color: #fff;
    text-align: start;
    margin-top: 16px;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    gap: 10px;
`;

export const Divider = styled.span`
    flex: 1;
    height: 1px;
    background: linear-gradient(to right, #d0bdf4, transparent);
`;

export const CarBrandsList = styled.div`
    display: grid;
    overflow-x: auto;
    grid-auto-flow: column;
    gap: 10px;

    ::-webkit-scrollbar {
        display: none;
    }
`;

export const CarBrandLogoContainer = styled.div`
    padding: 5px;
    background: rgba(255, 255, 255, 0.1);
    display: flex;
    height: 45px;
    width: 45px;

    justify-content: center;
    border-radius: 8px;
    align-items: center;
`;

export const BannerImg = styled.div`
    width: 300px;
    margin: 0 auto;
    opacity: 0;
    animation: ${slideUp} 0.4s 0.175s forwards;
`;

export const Content = styled.div`
    padding: 16px 20px;
    opacity: 0;
    animation: ${slideUp} 0.4s 0.2s forwards;
`;

export const ServicesTitle = styled.div`
    font-size: 18px;

    font-weight: 600;
    line-height: 24px;
    text-align: left;
    margin: 0 0 16px;
    opacity: 0;
    animation: ${slideUp} 0.4s 0.225s forwards;

    & > span {
        display: block;
        margin: 4px 0 0;
        color: #000;
        font-size: 14px;
        font-weight: 300;
        line-height: 20px;
    }
`;

export const Card = styled.div`
    align-items: flex-start;
    border-radius: 16px;
    border: 1px solid rgba(211, 173, 248, 0.4);
    background: linear-gradient(
        112deg,
        rgba(95, 28, 127, 0.7) -46.87%,
        rgba(96, 71, 137, 0) 141.81%
    );
    align-self: stretch;
    display: flex;
    margin-top: 16px;
    margin-right: -20px;
    width: 100%;
    flex-grow: 1;
    display: flex;
    padding: 14px;
    flex-direction: column;
    animation: ${slideUp} 0.4s 0.25s forwards;
    color: #fff;
    overflow: hidden;
    box-sizing: border-box;

    & p {
        margin: 5px 0;
        font-size: 14px;
        line-height: 18px;
    }

    &::before {
        position: absolute;
        content: url('${resolvePath('/images/pattern.svg')}');
        top: 0;
        right: 5px;
    }
`;

export const OfferCapsule = styled.div`
    color: #121212;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px;
    border-radius: 32px;
    padding: 5px 12px;
    margin: 5px 0;
    background: linear-gradient(180deg, #ffe9a1 0%, #e8c44f 100%);
`;
export const OfferCapsuleText = styled.text`
    color: #121212;
    font-size: 12px;
    font-family: 'Euclid Circular B', 'Inter', sans-serif;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
    border-radius: 32px;
    padding: 5px 4px 5px 0;
    margin: 5px 0;
    background: linear-gradient(180deg, #ffe9a1 0%, #e8c44f 100%);
`;
export const OfferCapsuleText2 = styled.text`
    color: #121212;
    font-size: 12px;
    font-family: 'Euclid Circular B', 'Inter', sans-serif;
    font-style: normal;
    font-weight: 600;
    line-height: 18px;
    border-radius: 32px;
    padding: 5px 5px 5px 0;
    margin: 5px 0;
    background: linear-gradient(180deg, #ffe9a1 0%, #e8c44f 100%);
`;

export const CardOffer = styled.div`
    display: flex;
    flex-direction: column;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;

    color: #fff;
    text-align: left;
    & > b {
        line-height: 32px;
        -webkit-text-fill-color: transparent;
        -webkit-background-clip: text !important;
        background: linear-gradient(90.51deg, #9f8ae1, #9276e9 61.46%, #b6a0fb);
        text-align: left;
        align-items: center;
        font-size: 14px;
    }
    & > div {
        font-size: 22px;
        font-weight: 700;
        -webkit-text-fill-color: transparent;
        -webkit-background-clip: text !important;
        background: linear-gradient(90.51deg, #7cc8ff, #88fff1 61.46%, #b6a0fb);
    }
    & > p {
        color: #f0f0f6;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        letter-spacing: -0.2px;
    }
`;

export const CarName = styled.span`
    background: linear-gradient(305deg, #ffe3a3 39.28%, #f5b8e4 65.51%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
`;

export const CardTitle = styled.div`
    color: #040222;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
`;

export const PriceTitle = styled.div`
    color: #040222;
    font-size: 22px;
    font-weight: 700;
    line-height: 32px;

    margin: 4px 0 0;
`;

export const ViewMoreLink = styled.div`
    text-align: center;
    font-size: 12px;
    color: #b191ed;
    display: flex;

    width: 100%;
    justify-content: space-between;
    font-weight: 500;
    line-height: 20px;
    //padding: 12px 0 0;
    //margin: 16px 0 0;
    align-items: center;
    cursor: pointer;
    & > span {
        height: 10px;
        width: 10px;
        border: 2px solid transparent;
        border-left: 2px solid #ffffff;
        border-bottom: 2px solid #ffffff;
        transform: rotate(225deg);
        border-radius: 2px;
        cursor: pointer;
    }
`;

export const ThanksContent = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin: 100px 0 0 0;
`;

export const NotEligibleContainer = styled.div`
    border-radius: 8px;
    border: 1px solid rgba(255, 227, 128, 0.7);
    background: #fff7e5;
    display: flex;
    margin-top: 16px;
    padding: 12px;
    color: #121212;
    gap: 8px;
    align-items: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
`;

export const DashedDiv = styled.div`
    border-top: 1px dashed #f0f0f6;
    margin: 16px 0;
    width: 100%;
    height: 1px;
`;

export const ThanksIcon = styled.img`
    margin: auto;
    display: block;
    opacity: 0;
    animation: ${slideUp} 0.3s 0.25s forwards;
`;

export const ThanksTitle = styled(ServicesTitle)`
    text-align: center;
    font-size: 22px;
    letter-spacing: 1px;
    line-height: 24px;

    color: #b09bff;
    text-shadow: 0px 4px 0px rgba(255, 255, 255, 0);
    animation: ${slideUp} 0.3s 0.3s forwards;
`;

export const ThanksInfo = styled.div`
    color: #fff;

    text-align: center;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    opacity: 0;
    & > span {
        font-weight: 700;
    }
    animation: ${slideUp} 0.3s 0.35s forwards;
`;

export const CarouselCard = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    font-family: 'Euclid Circular B', 'Inter', sans-serif;
    align-self: stretch;
    padding: 12px;
    color: white;
    gap: 8px;
    & > span {
        font-size: 12px;
        line-height: 14px;
        font-weight: 500;
        color: #f8f7fc;
        text-align: left;
    }
`;

export const Offer = styled.div`
    background: linear-gradient(93deg, #7465ac -0.24%, #603371 103.17%);
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.15);
    width: 100%;
    white-space: pre-wrap;

    height: 36px;
    text-align: center;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 12px;
    font-size: 12px;
    font-weight: 400;
    line-height: 12px;
    text-align: left;
    overflow: hidden;

    & > div {
        width: 12px;
        background: rgba(255, 255, 255, 0.5);
        height: 100%;
        transform: skewX(-15deg);
        left: -60px;
        position: relative;
        animation: moveLeftRight 3s linear infinite;
        // animation-iteration-count: 2;
    }
    & > div:nth-child(2) {
        width: 4px;
        background: rgba(255, 255, 255, 0.5);
        margin-left: 4px;
        height: 100%;
        transform: skewX(-15deg);
        position: relative;
        //left: 55px;
    }
    & > span {
        font-weight: 700;
        /* padding: 0 4px; */
    }
    @media (max-width: 700px) {
        position: fixed;
        bottom: 58px;
    }

    @keyframes moveLeftRight {
        0% {
            left: -40px;
        }
        100% {
            left: 100%;
        }
    }
`;

export const Container = styled.div`
    padding: 4px 20px;
    margin-bottom: 5px;
`;

export const ContainerBox = styled.div`
    display: flex;
    flex-direction: column;
    & > div {
        display: flex;
        margin-top: 40px;
        flex-direction: column;
    }
`;
export const TermsTitle = styled.div`
    font-size: 16px;
    line-height: 22px;

    color: #fff;
`;

export const Voucher = styled.div`
    height: 108px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    background: linear-gradient(
        96deg,
        #7c47e1 -13.84%,
        #644fa1 40.99%,
        #ca1ee5 103.13%
    );
    -webkit-box-shadow: inset 0 0 0 1px white;
    overflow: hidden;
    align-items: center;
    margin: 12px auto;
`;

export const Ellipse = styled.div`
    border-radius: 50%;
    background-color: black;
    border: 1px solid white;
    width: 12px;
    height: 12px;
`;
export const PunchLeft = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    height: 100%;
    justify-content: center;
    position: relative;
    left: -5px;
`;
export const PunchRight = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    justify-content: center;
    position: relative;
    right: -5px;
`;

export const VoucherHelperText = styled.div`
    font-size: 12px;
    line-height: 18px;

    color: #fff;
    text-align: center;
    display: flex;
    align-items: center;
    gap: 4px;
    justify-content: center;
    & > span > a {
        color: green;
        //text-decoration: none;
    }
`;
export const VoucherTitle = styled.div`
    font-size: 14px;
    line-height: 32px;

    color: #f0f0f6;
    text-align: center;
`;

export const VoucherDetails = styled.div`
    display: flex;
    height: 80px;
    flex-direction: column;
    padding: 14px 10px;
    border: 1px dashed #fff;
    font-family: 'Euclid Circular B', 'Inter', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    color: #fff;
    align-items: center;
    animation: ${slideUp} 0.4s 0.125s forwards;
`;
export const VoucherAmount = styled.div`
    font-family: 'Euclid Circular B', 'Inter', sans-serif;
    font-size: 18px;
    line-height: 32px;
    color: #fff;
    text-align: left;
    font-weight: 700;
`;

export const HeaderBackContainer = styled.div`
    position: fixed;
    left: 10px;
    top: 10px;
    transform: rotate(180deg) scale(1.4);
`;

export const CtaDiv = styled.div`
    display: flex;
    flex-direction: column;
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    & > span {
        font-size: 12px;
        font-weight: 500;
        line-height: 18px;
        position: relative;
    }
`;
